import { render } from "./BasicDataManager.vue?vue&type=template&id=3a682f7d"
import script from "./BasicDataManager.vue?vue&type=script&lang=js"
export * from "./BasicDataManager.vue?vue&type=script&lang=js"
script.render = render

export default script